import React, { useContext, useEffect, useState } from 'react'
import { QuizQuestionContext, SCREEN_QUIZ_QUESTION } from '../contextAPI'

export const QuizProgressBar = () => {
  const { screen, quizProgressPercent, setQuizProgressPercent } = useContext(QuizQuestionContext)
  const [percentage, setPercentage] = useState(quizProgressPercent)

  useEffect(() => {
    switch (screen) {
      case SCREEN_QUIZ_QUESTION.WEDDING_DATE:
        setPercentage(25)
        setQuizProgressPercent(25)
        break
      case SCREEN_QUIZ_QUESTION.YOU_BOOKED:
        setPercentage(50)
        setQuizProgressPercent(50)
        break
      case SCREEN_QUIZ_QUESTION.BUDGET:
        setPercentage(75)
        setQuizProgressPercent(75)
        break
      default:
        setPercentage(100)
        setQuizProgressPercent(100)
        break
    }
  }, [screen, setQuizProgressPercent])

  return (
    <>
      <div className="quiz-progress-bar">
        <div className="progress-percentage" style={{ width: `${percentage}%` }}></div>
      </div>
    </>
  )
}
